import { render, staticRenderFns } from "./WineEdit_Mobile.vue?vue&type=template&id=27db144d&scoped=true&"
import script from "./WineEdit_Mobile.vue?vue&type=script&lang=js&"
export * from "./WineEdit_Mobile.vue?vue&type=script&lang=js&"
import style0 from "./WineEdit_Mobile.vue?vue&type=style&index=0&id=27db144d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27db144d",
  null
  
)

export default component.exports